import { z } from 'zod'

export const FORM_ID = 'edit-birthday-form'
export const schema = z.object({
  birthday: z.date(),
})
export type FormValues = z.infer<typeof schema>
